import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import CreditsDialog from "@/components/CreditsDialog";

const CreditsContext = createContext(null);
export const useCredits = () => useContext(CreditsContext) || {};

export function CreditsProvider({ children }) {
  const { user } = useAuth();
  const [credits, setCredits] = useState(null);
  const [topUpOpen, setTopUpOpen] = useState(false);
  const [outOfCredits, setOutOfCredits] = useState(null); // {needed, balance}

  const refresh = useCallback(async () => {
    if (!user) { setCredits(null); return null; }
    try {
      const { data } = await api.get("/credits");
      setCredits(data);
      return data;
    } catch {
      return null;
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    const handler = (e) => {
      const d = e.detail || {};
      setOutOfCredits({ needed: d.needed, balance: d.balance });
      setTopUpOpen(true);
      refresh();
    };
    window.addEventListener("codex:out-of-credits", handler);
    return () => window.removeEventListener("codex:out-of-credits", handler);
  }, [refresh]);

  const openTopUp = useCallback(() => { setOutOfCredits(null); setTopUpOpen(true); }, []);

  return (
    <CreditsContext.Provider
      value={{ credits, refresh, openTopUp, topUpOpen, setTopUpOpen, outOfCredits, setOutOfCredits }}
    >
      {children}
      <CreditsDialog />
    </CreditsContext.Provider>
  );
}
